import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkNotesOperations = ({ 
  selectedCount, 
  onBulkPrint, 
  onBulkStatusUpdate, 
  onClearSelection 
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-fab">
      <div className="bg-surface rounded-lg shadow-modal border border-border p-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="text-sm font-body-medium text-text-primary">
              {selectedCount} {selectedCount === 1 ? 'albarán seleccionado' : 'albaranes seleccionados'}
            </span>
          </div>

          <div className="h-6 w-px bg-border"></div>

          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Printer"
              onClick={onBulkPrint}
            >
              Imprimir todo
            </Button>

            <div className="relative group">
              <Button
                variant="outline"
                size="sm"
                iconName="Package"
              >
                Cambiar estado
              </Button>
              <div className="absolute bottom-full left-0 mb-2 w-48 bg-surface rounded-lg shadow-modal border border-border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-micro z-dropdown">
                <div className="py-2">
                  <button
                    onClick={() => onBulkStatusUpdate('pending')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Clock" size={16} />
                    <span>Marcar como pendiente</span>
                  </button>
                  <button
                    onClick={() => onBulkStatusUpdate('in_progress')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="Truck" size={16} />
                    <span>Marcar en progreso</span>
                  </button>
                  <button
                    onClick={() => onBulkStatusUpdate('completed')}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-text-secondary hover:bg-secondary-50 hover:text-text-primary"
                  >
                    <Icon name="CheckCircle" size={16} />
                    <span>Marcar como completado</span>
                  </button>
                </div>
              </div>
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                // Export selected delivery notes
                console.log('Exporting delivery notes...');
              }}
              iconName="Download"
            >
              Exportar
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
            >
              Limpiar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkNotesOperations;